export const TEXTS = {
  CONTINUE_TO_CHECKOUT: 'Proceed to Buy',
  VIEW_DETAILS: 'View Details',
  CONTINUE_TO_PAYMENT: 'Proceed to Pay',
  REWARDS_TEXT_SAVED: 'You saved ',
  REWARDS_TEXT_PURCHASE: ' on this purchase',
  PLEAESE_SELECT_ATLEAST_ONE_ITEM: 'Please select at least one item to proceed',
  SAVING_TEXT: "You're saving ",
  HURRY_SALE_ENDS_IN: ' Hurry! Sale ends in ',
  YOU_LL_SAVE: "You'll save",
  ON_THIS_ORDER: ' on this order',
  YOUR_SAVINGS: 'Your Savings',
};

export const SAVINGS_BREAKDOWN_LABELS = {
  DISCOUNT_ON_MRP: 'Discount on MRP',
  COUPONS_AND_OFFERS: 'Savings with coupons and offers',
  CONVENIENCE_CHARGES: 'Savings on platform fee',
  DELIVERY_FEE: 'Savings on packaging and delivery fee',
  TOTAL_SAVINGS: 'Total savings',
};

export const CART_CHARGES_TYPES = {
  PLATFORM_FEE: 'platformFee',
  SHIPPING_FEE: 'shippingFee',
} as const;

export const SAVINGS_STRIP_ARIA = {
  OPEN_BREAKDOWN: 'View savings breakdown',
  CLOSE_BREAKDOWN: 'Close savings breakdown',
  PRICE_INFO: 'View price and savings details',
};


export const SAVINGS_STRIP_IMAGES = {
  WAVY: 'https://images-static.nykaa.com/fashion-images/pub/media/fashion-images/savingstripimages/saving_wavy.png',
  RECTANGLE: 'https://images-static.nykaa.com/fashion-images/pub/media/fashion-images/savingstripimages/saving_rectangle.png',
};


export const SCREEN_TYPES = {
  CART: 'cart',
  ADDRESS: 'address',
};

export const FREE_GIFT_SESSION_KEY = 'freeGiftsNudgeShown';
